import React, { useState } from 'react'
import api from '../services/api'
import './TerminateContract.css'

const types = ['ลาออก', 'ตาย', 'เปลี่ยนตำแหน่ง', 'อื่นๆ']

export default function TerminateContract({ contract, onSaved, confirm }) {
  const [open, setOpen] = useState(false)
  const [type, setType] = useState('')
  const [customType, setCustomType] = useState('')
  const [date, setDate] = useState('')
  const [reason, setReason] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')

  if (contract.termination_date) {
    const scheduled = contract.status === 'completed'
    return (
      <section style={{ padding: 16, background: scheduled ? '#eff6ff' : '#fef2f2', borderRadius: 10, marginBottom: 16 }}>
        <strong>{scheduled ? 'กำหนดสิ้นสุดสัญญา' : 'สิ้นสุดสัญญาแล้ว'}</strong>
        <p>วันที่มีผล {new Date(contract.termination_date).toLocaleDateString('th-TH')} · เหตุ: {contract.termination_type}</p>
        <p>รายละเอียด: {contract.termination_reason}</p>
        {scheduled && <p>สัญญายังอยู่ในสถานะลงนามครบจนกว่าจะถึงวันที่มีผล</p>}
      </section>
    )
  }
  if (contract.status !== 'completed') return null

  const submit = async event => {
    event.preventDefault()
    setError('')
    const chosen = type === 'อื่นๆ' ? customType.trim() : type
    if (!chosen || !reason.trim() || !date) {
      setError('กรุณาเลือกเหตุ วันที่มีผล และระบุรายละเอียดให้ครบถ้วน')
      return
    }
    const approved = await confirm('warning', 'ยืนยันการสิ้นสุดสัญญา',
      `สัญญา ${contract.contract_no} · เหตุ ${chosen} · วันที่มีผล ${new Date(`${date}T00:00:00`).toLocaleDateString('th-TH')} ยืนยันตามเอกสารที่ตรวจสอบแล้วใช่หรือไม่?`)
    if (!approved) return
    setBusy(true)
    try {
      await api.post(`/contracts/${contract.id}/terminate`, { type, custom_type: type === 'อื่นๆ' ? customType.trim() : undefined, date, reason: reason.trim() })
      setOpen(false)
      await onSaved()
    } catch (err) {
      setError(err.response?.data?.message || 'บันทึกไม่สำเร็จ')
    } finally { setBusy(false) }
  }

  return (
    <section style={{ padding: 16, border: '1px solid #fecaca', marginBottom: 16, borderRadius: 10 }}>
      <button className="termination-action" type="button" aria-expanded={open} onClick={() => setOpen(!open)}>บันทึกสิ้นสุดสัญญาก่อนครบกำหนด</button>
      {open && (
        <form onSubmit={submit} style={{ display: 'grid', gap: 12, marginTop: 12 }}>
          <p>สำหรับสัญญาที่ลงนามครบแล้ว เลือกเหตุที่ตรงกับเอกสาร แล้วกำหนดวันที่มีผล ระบบเก็บสัญญา PDF ลายเซ็น และประวัติไว้</p>
          <fieldset style={{ border: '1px solid #dbe3ec', borderRadius: 8, padding: 10 }}>
            <legend>เหตุหลัก (เลือก 1 ข้อ)</legend>
            {types.map(option => (
              <label key={option} style={{ display: 'block', padding: '5px 0' }}>
                <input type="radio" name={`termination-type-${contract.id}`} value={option} checked={type === option}
                  onChange={() => { setType(option); setError('') }} required /> {option}
              </label>
            ))}
          </fieldset>
          {type === 'อื่นๆ' && (
            <label>ระบุเหตุอื่น
              <input required minLength={2} maxLength={120} value={customType} onChange={event => setCustomType(event.target.value)}
                placeholder="ระบุเหตุให้ตรงกับเอกสาร" style={{ display: 'block', width: '100%', boxSizing: 'border-box' }} />
            </label>
          )}
          <label>วันที่มีผล
            <input required type="date" value={date} onChange={event => setDate(event.target.value)} style={{ display: 'block' }} />
          </label>
          <p style={{ fontSize: 12, color: '#475569' }}>วันที่มีผลต้องก่อนวันครบกำหนดสัญญา หากเลือกวันล่วงหน้า ระบบจะเปลี่ยนสถานะเมื่อถึงวันนั้น</p>
          <label>รายละเอียดเหตุผลตามเอกสาร
            <textarea required maxLength={2000} value={reason} onChange={event => setReason(event.target.value)}
              placeholder="ระบุรายละเอียดและเลขที่เอกสารหรือคำสั่งที่เกี่ยวข้อง" style={{ display: 'block', width: '100%', boxSizing: 'border-box' }} />
          </label>
          {error && <p role="alert" style={{ color: '#b91c1c' }}>{error}</p>}
          <button className="termination-action" disabled={busy} type="submit">{busy ? 'กำลังบันทึก...' : 'ตรวจสอบและยืนยัน'}</button>
        </form>
      )}
    </section>
  )
}
